import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {StorageMap} from '@ngx-pwa/local-storage';
import {AuthResponse} from '../../shared/interfaces/auth-response';
import {Observable} from 'rxjs';
import {AngularFireAuth} from '@angular/fire/auth';
import firebase from 'firebase';
import UserCredential = firebase.auth.UserCredential;
import {IClient} from '../../shared/interfaces/IClient';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  userData: Observable<firebase.User>;
  constructor(private httpClient: HttpClient, private storage: StorageMap, private angularFireAuth: AngularFireAuth) {
    this.userData = angularFireAuth.authState;
  }

  getUser(): Observable<IClient> {
    return this.httpClient.get<IClient>(`${this.apiUrl}client/me`);
  }
  login(email: string, password: string): Observable<AuthResponse> {
    const data = {
      email,
      password
    };
    return this.httpClient.post<AuthResponse>(`${this.apiUrl}auth/login`, data);
  }


  /* Sign up */
  signUp(email: string, password: string): Promise<UserCredential> {
    return this.angularFireAuth
      .createUserWithEmailAndPassword(email, password);
  }

  /* Sign in */
  signIn(email: string, password: string): Promise<UserCredential> {
    return this.angularFireAuth
      .signInWithEmailAndPassword(email, password);
  }

  /* Sign out */
  signOut(): Promise<any> {
    return this.angularFireAuth
      .signOut();
  }
}
